import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

const initialState = {
  company_type: "Finance",
  company_name: "",
  company_coordinator_name: "",
  company_coordinator_mobile_no: "",
  company_contact_persons: [{ name: "", mobile_no: "" }], // Initialize with one empty contact person
  company_official_email: "",
  branch_name: "",
  company_location: "",
  status: "Active",
  _id: ""
};

const AddCompany = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [values, setValues] = useState(initialState);
  const { state } = useLocation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  // Handle changes to contact person fields
  const handleContactPersonChange = (index, field, value) => {
    const updatedContactPersons = [...values.company_contact_persons];
    updatedContactPersons[index] = {
      ...updatedContactPersons[index],
      [field]: value
    };
    
    setValues({
      ...values,
      company_contact_persons: updatedContactPersons
    });
  };

  // Add a new contact person
  const addContactPerson = () => {
    setValues({
      ...values,
      company_contact_persons: [
        ...values.company_contact_persons,
        { name: "", mobile_no: "" }
      ]
    });
  };

  // Remove a contact person at specific index
  const removeContactPerson = (index) => {
    if (values.company_contact_persons.length === 1) {
      toast.warning("At least one contact person is required");
      return;
    }
    
    const updatedContactPersons = values.company_contact_persons.filter((_, i) => i !== index);
    setValues({
      ...values,
      company_contact_persons: updatedContactPersons
    });
  };

  const saveUpdateCompany = () => {
    const token = localStorage.getItem('token');
    if (!values.company_name) {
      toast.error("Please enter company name!");
      return;
    }

    // Validate contact persons
    const hasEmptyContactPerson = values.company_contact_persons.some(
      person => !person.name || !person.mobile_no
    );
    
    if (hasEmptyContactPerson) {
      toast.error("Please fill all contact person details or remove empty entries");
      return;
    }

    let api = "addCompany";
    if (values._id !== "") {
      api = "updateCompany";
    }
    
    setLoading(true);
    axios
      .post(`${BASE_URL}admin/${api}`, values, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "Application/json",
          version: "1.0.0",
        },
      })
      .then((response) => {
        if (response.data.success) {
          setLoading(false);
          setValues(initialState);
          toast.success(response.data.message);
          navigate("/company-listing")
        } else {
          setLoading(false);
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err.message);
      });
  };

  useEffect(() => {
    if (state && state.item) {
      // If editing an existing company
      const companyData = state.item;
      
      // Ensure company_contact_persons is an array with at least one item
      const contactPersons = Array.isArray(companyData.company_contact_persons) && 
                            companyData.company_contact_persons.length > 0 
                            ? companyData.company_contact_persons 
                            : [{ name: companyData.company_contact_person_name || "", 
                                mobile_no: companyData.company_contact_person_mobile_no || "" }];
      
      setValues({ 
        ...companyData,
        company_contact_persons: contactPersons
      });
    }
  }, [state]);

  return (
    <Layout>
      <div className="content-i">
        <div className="content-box">
          <div className="row">
            <div className="col-lg-12">
              <div className="element-wrapper">
                <h6 className="element-header">Company</h6>
                <div className="element-box">
                  <div>
                    <h5 className="form-header">Add Company</h5>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Select Company Type:</label>
                          <select
                            className="form-control"
                            onChange={(e) => handleInputChange(e)}
                            name="company_type"
                            value={values.company_type}
                          >
                            <option disabled>--select--</option>
                            <option value="Finance">Finance</option>
                            <option value="Insurance">Insurance</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Company Name:</label>
                          <input
                            className="form-control"
                            placeholder="Enter Company Name"
                            name="company_name"
                            onChange={(e) => handleInputChange(e)}
                            value={values.company_name}
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Company Coordinator Name</label>
                          <input
                            className="form-control"
                            placeholder="Enter Company Coordinator Name"
                            name="company_coordinator_name"
                            onChange={(e) => handleInputChange(e)}
                            value={values.company_coordinator_name}
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Company Coordinator Mobile No</label>
                          <input
                            className="form-control"
                            placeholder="Enter Company Coordinator Mobile No"
                            name="company_coordinator_mobile_no"
                            onChange={(e) => handleInputChange(e)}
                            value={values.company_coordinator_mobile_no}
                            type="text"
                          />
                        </div>
                      </div>

                      {/* Contact Persons Section */}
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label className="d-flex justify-content-between align-items-center">
                            <span>Company Contact Persons</span>
                            <button 
                              type="button" 
                              className="btn btn-sm btn-primary" 
                              onClick={addContactPerson}
                            >
                              Add Person
                            </button>
                          </label>
                          
                          {values.company_contact_persons.map((person, index) => (
                            <div key={index} className="card mb-3 p-3">
                              <div className="row">
                                <div className="col-sm-5">
                                  <div className="form-group">
                                    <label>Name</label>
                                    <input
                                      className="form-control"
                                      placeholder="Enter Contact Person Name"
                                      type="text"
                                      value={person.name}
                                      onChange={(e) => handleContactPersonChange(index, 'name', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-5">
                                  <div className="form-group">
                                    <label>Mobile No</label>
                                    <input
                                      className="form-control"
                                      placeholder="Enter Contact Person Mobile No"
                                      type="text"
                                      value={person.mobile_no}
                                      onChange={(e) => handleContactPersonChange(index, 'mobile_no', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-2 d-flex align-items-end">
                                  <button 
                                    type="button" 
                                    className="btn btn-danger mb-3" 
                                    onClick={() => removeContactPerson(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Company Official Email</label>
                          <input name="company_official_email"
                            className="form-control"
                            placeholder="Enter Company Official Email"
                            type="email"
                            onChange={(e) => handleInputChange(e)}
                            value={values.company_official_email}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Branch Name</label>
                          <input name="branch_name"
                            className="form-control"
                            placeholder="Enter Branch Name"
                            type="text"
                            onChange={(e) => handleInputChange(e)}
                            value={values.branch_name}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Company Location</label>
                          <input name="company_location"
                            className="form-control"
                            placeholder="Enter Company Location"
                            type="text"
                            onChange={(e) => handleInputChange(e)}
                            value={values.company_location}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor>Status</label>
                          <select
                            className="form-control"
                            onChange={(e) => handleInputChange(e)}
                            name="status"
                            value={values.status}
                          >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="form-buttons-w">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        onClick={() => saveUpdateCompany()}
                      >
                        {
                          loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Submit"
                          )
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AddCompany;